import { Component, OnInit } from '@angular/core';
declare let $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {

    $(document).ready(function () {

      'use strict'

      $('ul li:has(ul)').addClass('has-submenu');
      $('ul li ul').addClass('sub-menu');

      $('ul.dropdown li').hover(function () {
        $(this).addClass('hover');

      },
        function () {
          $(this).removeClass('hover');
        });

      var $menu = $('#menu'),
      $menulink = $('#menu-toggle-form'),
      $menuitem = $('.nav-route'),
      $menuTrigger = $('.has-submenu > a');
      
      $menuitem.click(function (e) {
        // $menulink.toggleClass('active');
        $menu.toggleClass('active');
      });
      
      $menulink.click(function (e) {
          // $menulink.toggleClass('active');
          $menu.toggleClass('active');
      });

      $menuTrigger.click(function (e) {
        e.preventDefault();
        var t = $(this);
        t.toggleClass('active').next('ul').toggleClass('active');
      });

      $('ul li:has(ul)');
    });

  }

}
